import { useQuery } from '@tanstack/react-query';
import { subcontractRequestsApi } from '@/lib/apiClient';
import { StateView } from '@/components';
import SubcontractRequestList from './SubcontractRequestList';

/**
 * The caller's own subcontract requests on one job (#627), drafts included, for the job's Contracts tab: where a
 * project manager picks a draft back up, sees whether the coordinator has numbered it, or opens one to withdraw it.
 *
 * `mine` is the caller's requests across every job, so the job is picked out here. Someone with no right to start
 * a request (`canRequest` false on the tab) never reaches this: the API would answer 403.
 */
export default function JobSubcontractRequests({ projectId }: { projectId: number }) {
  const q = useQuery({
    queryKey: ['contracts', 'requests', 'mine'],
    queryFn: () => subcontractRequestsApi.mine(),
    staleTime: 30_000,
  });
  return (
    <StateView query={q} isEmpty={() => false}>
      {(items) => {
        const here = items.filter((r) => r.projectId === projectId);
        // Nothing on this job: no empty box to look at, the button above is the way in.
        if (here.length === 0) return null;
        return (
          <SubcontractRequestList
            title="Your subcontract requests on this job"
            titleId="ct-requests-mine"
            items={here}
            showJob={false}
            showRequester={false}
            empty="You haven’t requested a subcontract on this job."
          />
        );
      }}
    </StateView>
  );
}
